export default "__VITE_ASSET__17587418__$_?react__"